export default "__VITE_ASSET__CzMsECHH__"